const steps = [
  {
    time: "07-28 21:10",
    title: "第一块砖：单场直播销售额破纪录引围观",
    body: "当晚销售额冲上平台前三，团队晒出「助农专场」战报，贾大嘴公开喊话「一分钱不提成」，吸粉数十万。",
    type: "铺垫",
  },
  {
    time: "08-02 14:00",
    title: "裂缝出现：合作商家晒出结算单",
    body: "一名自称供货商的账号晒出后台结算截图，显示佣金比例高达 40%，与公开承诺明显冲突，帖子迅速被限流。",
    type: "质疑",
  },
  {
    time: "08-09 09:30",
    title: "塌房现场：多份协议被逐页比对",
    body: "网友联合整理 6 段后台录屏与 3 份合作协议，按场次还原真实分成，实锤连线图在评论区刷屏。",
    type: "发酵",
  },
  {
    time: "08-15 22:00",
    title: "脱粉瞬间：一夜掉粉破百万",
    body: "工作室声明口径前后矛盾，老粉发起「脱粉接力」，超话管理组集体改号，人设崩塌进入公开倒计时。",
    type: "崩塌",
  },
  {
    time: "08-21 现在",
    title: "口碑崩盘：品牌方陆续官宣解约",
    body: "三家合作品牌先后「合约到期」切割，舆论场开始考古早年人设文案，呱呱黑料持续跟进实时复盘。",
    type: "清算",
  },
];

const typeStyle: Record<string, string> = {
  铺垫: "bg-background-100 text-foreground-600",
  质疑: "bg-secondary-100 text-secondary-700",
  发酵: "bg-accent-100 text-accent-800",
  崩塌: "bg-primary-100 text-primary-700",
  清算: "bg-foreground-950 text-background-50",
};

export default function Timeline() {
  return (
    <section id="timeline" className="w-full bg-background-50 py-10 md:py-14">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="mb-6 md:mb-9">
          <p className="mb-1.5 text-xs font-bold uppercase tracking-[0.2em] text-accent-600">
            Full Timeline · 人设崩塌的全记录
          </p>
          <h3 className="font-display text-2xl font-black text-foreground-950 md:text-[34px] md:leading-tight">
            主播「贾大嘴」从滤镜破碎到口碑崩盘
          </h3>
          <p className="mt-1.5 max-w-2xl text-sm text-foreground-600">
            按时间顺序收录的每一步，从公开承诺到合作结算、从脱粉瞬间到品牌解约，谁在什么时候、怎么塌的，一帧都不跳过。
          </p>
        </div>

        <div className="grid gap-6 md:gap-8 lg:grid-cols-12">
          {/* 左侧人物档案卡 */}
          <aside className="lg:col-span-4">
            <div className="sticky top-24 overflow-hidden rounded-2xl border border-background-200/80 bg-background-100/60 shadow-card">
              <div className="relative h-44">
                <img
                  src="https://readdy.ai/api/search-image?query=Editorial%20press%20photograph%20of%20a%20live%20streaming%20studio%20desk%20with%20ring%20light%20glowing%20in%20darkness%2C%20empty%20chair%20turned%20away%2C%20product%20boxes%20and%20microphone%2C%20deep%20red%20and%20amber%20accent%20lighting%2C%20grainy%2035mm%2C%20dramatic%20shadows%2C%20documentary%20expose%20mood&width=800&height=480&seq=gk-tl-portrait&orientation=landscape"
                  alt="呱呱黑料贾大嘴助农直播塌房案例档案配图"
                  className="h-full w-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-100/90 to-transparent"></div>
                <span className="absolute left-4 top-4 inline-flex items-center gap-1 rounded-full bg-foreground-950/80 px-2.5 py-1 text-[11px] font-bold text-background-50 backdrop-blur">
                  <i className="ri-focus-3-fill text-accent-300"></i>
                  在追 · 已核实
                </span>
              </div>
              <div className="-mt-8 px-5 pb-5 md:px-6 md:pb-6">
                <h4 className="font-display text-xl font-black text-foreground-950">贾大嘴</h4>
                <p className="mt-0.5 text-xs text-foreground-500">头部带货主播 · 助农人设</p>

                <div className="mt-4 space-y-3">
                  <div>
                    <div className="mb-1 flex items-center justify-between text-xs">
                      <span className="font-medium text-foreground-600">好感度（已脱粉）</span>
                      <span className="font-black text-primary-600">-82%</span>
                    </div>
                    <div className="h-2 overflow-hidden rounded-full bg-background-200">
                      <div className="h-full w-[18%] rounded-full bg-gradient-to-r from-primary-500 to-accent-500"></div>
                    </div>
                  </div>
                  <div>
                    <div className="mb-1 flex items-center justify-between text-xs">
                      <span className="font-medium text-foreground-600">口碑崩盘指数</span>
                      <span className="font-black text-foreground-950">86%</span>
                    </div>
                    <div className="h-2 overflow-hidden rounded-full bg-background-200">
                      <div className="h-full w-[86%] rounded-full bg-gradient-to-r from-accent-500 to-primary-600"></div>
                    </div>
                  </div>
                </div>

                <div className="mt-4 flex flex-wrap gap-2">
                  {["助农返佣", "口头承诺", "协议实锤", "品牌解约"].map((t) => (
                    <span
                      key={t}
                      className="whitespace-nowrap rounded-full bg-background-50 px-2.5 py-1 text-[11px] font-medium text-foreground-600 ring-1 ring-background-200"
                    >
                      # {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </aside>

          {/* 右侧时间线 */}
          <div className="relative lg:col-span-8">
            <div className="absolute bottom-2 left-[13px] top-2 w-px bg-background-200 md:left-[15px]"></div>
            <ul className="space-y-4 md:space-y-5">
              {steps.map((s, idx) => (
                <li key={s.title} className="relative flex gap-4 md:gap-6">
                  <span className="relative z-10 mt-1.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-background-50 ring-4 ring-background-50 md:h-7 md:w-7">
                    <span
                      className={`flex h-3 w-3 items-center justify-center rounded-full md:h-3.5 md:w-3.5 ${
                        idx === steps.length - 1 ? "bg-primary-500" : "bg-accent-500"
                      }`}
                    ></span>
                  </span>
                  <div className="flex-1 rounded-2xl border border-background-200/80 bg-background-100/50 px-4 py-4 shadow-card transition-colors hover:border-accent-300 md:px-5">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="inline-flex items-center gap-1 text-xs font-semibold text-foreground-500">
                        <i className="ri-calendar-line"></i>
                        {s.time}
                      </span>
                      <span
                        className={`whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-bold ${typeStyle[s.type]}`}
                      >
                        {s.type}
                      </span>
                    </div>
                    <h4 className="mt-1.5 text-[15px] font-bold text-foreground-950">{s.title}</h4>
                    <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">{s.body}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}